import {useMemo} from 'react';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import ActiveJobPositions from '@/src/jobPortal/clinicPositions/containers/ActiveJobPositions';
import ArchiveJobPositions from '@/src/jobPortal/clinicPositions/containers/ArchiveJobPositions';
import ClinicPositionsSidebar from '@/src/jobPortal/clinicPositions/containers/ClinicPositionsSidebar';
import DraftJobPositions from '@/src/jobPortal/clinicPositions/containers/DraftJobPositions';
import {
  jopPositionsFilterProps,
  STATUSES_JOBS,
} from '@/src/jobPortal/clinicPositions/hooks/useClinicPositions';
import JobPortalActivePage from '@/src/jobPortal/common/containers/JobPortalActivePage';
import JopPortalManagePermission from '@/src/jobPortal/common/containers/JopPortalManagePermission';
import MainContainer from '@/src/main/container/MainContainer';
import {LoadingWrapper, SectionContainer} from '@/src/ui';
import ViewWithSideBar from '@/src/ui/views/ViewWithSideBar/components/ViewWithSideBar';

import css from '../styles/filters.module.css';

interface ClinicPositionsLayoutProps {
  filter: jopPositionsFilterProps;
  isLoading: boolean;
  isActiveHeaderAddButton: boolean;
}

const ClinicPositionsLayout = ({
  filter,
  isLoading,
  isActiveHeaderAddButton,
}: ClinicPositionsLayoutProps) => {
  const mainContentNode = useMemo(
    () => (
      <div className={css.tablesWrapper}>
        {filter[SEARCH_FILTERS.FILTERS_STATUS] === STATUSES_JOBS.ACTIVE && (
          <ActiveJobPositions />
        )}
        {filter[SEARCH_FILTERS.FILTERS_STATUS] === STATUSES_JOBS.DRAFT && (
          <DraftJobPositions />
        )}
        {filter[SEARCH_FILTERS.FILTERS_STATUS] === STATUSES_JOBS.ARCHIVED && (
          <ArchiveJobPositions />
        )}
      </div>
    ),
    [filter]
  );

  return (
    <MainContainer
      topOffset={MainContainer.TOP_OFFSET.OFFSET_0}
      widthContainer={MainContainer.CONTAINER_WIDTH.FULL_WIDTH}
    >
      <JopPortalManagePermission>
        <JobPortalActivePage isActiveAddButton={isActiveHeaderAddButton}>
          <SectionContainer>
            <ViewWithSideBar
              sideBarSize={ViewWithSideBar.SIDEBAR_SIZE.SIZE_280}
              sideBar={<ClinicPositionsSidebar />}
              mainContent={
                <LoadingWrapper
                  isLoading={isLoading}
                  indicatorPosition={LoadingWrapper.INDICATOR_POSITION.ABSOLUTE}
                >
                  {mainContentNode}
                </LoadingWrapper>
              }
            />
          </SectionContainer>
        </JobPortalActivePage>
      </JopPortalManagePermission>
    </MainContainer>
  );
};

export default ClinicPositionsLayout;
